import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { baseUrl } from '../../../../../config/route-entry-point';
import cn from 'classname';

const propTypes = {
	unreadMsgs: PropTypes.number,
	userData: PropTypes.object,
	intl: PropTypes.func
};

const getMenuConfig = (intl, isMaster, unreadMsgs, user) => [
	{
		className: 'dashboard',
		title: intl('Дашборд'),
		link: '/dashboard'
	},
	{
		className: 'statistics',
		title: intl('Статистика'),
		link: baseUrl('statistics/')
	},
	// {
	// 	className: 'areas',
	// 	title: intl('Площадки'),
	// 	link: baseUrl('spaces/')
	// },
	{
		className: 'offers',
		title: intl('Офферы'),
		link: baseUrl('offers/')
	},
	{
		className: 'streams',
		title: intl('Потоки'),
		link: baseUrl('campaigns/')
	},
	{
		className: 'tools',
		title: intl('Инструменты'),
		link: baseUrl('tools/'),
		preventDefault: true,
		dropdown: [
			{
				title: intl('API конверсий'),
				link: baseUrl('user-api/'),
				className: 'conversions-api'
			},
			{
				title: intl('API кабинета'),
				link: 'https://docs.rocketprofit.com',
				className: 'dashboard-api',
				type: 'external'
			},
			{
				title: intl('Мастер-Аккаунты'),
				link: baseUrl('master-account/'),
				className: 'conversions-api',
				shouldExclude: user.general.language !== 'ru'
			},
			{
				title: intl('Настройка постбека'),
				link: baseUrl('postback-info/'),
				className: 'conversions-api'
			},
			{
				title: intl('Интеграция с Keitaro'),
				link: baseUrl('keitaro-integration/'),
				className: 'conversions-api'
			}/*,
			{
				title: intl('БМ Аккаунты'),
				link:baseUrl('bm-accounts/'),
				className: 'conversions-api'
			}*/
		]
	},
	{
		className: 'affiliates',
		title: intl('Вебмастера'),
		link: baseUrl('affiliates/'),
		shouldExclude: !isMaster
	},
	{
		className: 'finance',
		title: intl('Финансы'),
		link: baseUrl('finances/')
	},
	{
		className: 'goods-store',
		title: intl('Магазин'),
		link: baseUrl('market/')
	},
	{
		className: 'news',
		title: intl('Новости'),
		link: baseUrl('news/')
	},
	{
		className: 'support',
		title: intl('Поддержка'),
		link: baseUrl('tickets/'),
		unread: unreadMsgs
	}
];

const Menu = ({ unreadMsgs, userData, intl }) => {
	const isMaster = userData && userData.general && userData.general.is_master;
	return (
		<nav className="menu font-proxima-nova-semibold">
			<ul>
				{getMenuConfig(intl, isMaster, unreadMsgs, userData).map(
					(item, key) =>
						!item.shouldExclude && (
							<li key={key} className={item.dropdown && 'dropdown'}>
								<Link
									to={item.link}
									onClick={e => {
										item.preventDefault && e.preventDefault();
									}}
									className={cn(item.className, item.dropdown && 'dropdown__head')}
									activeClassName="active"
								>
									<span className="title">
										{item.title}
										{item.unread > 0 && <span className="unread">{item.unread}</span>}
									</span>
								</Link>
								{item.dropdown && (
									<div className="dropdown_suggests">
										{item.dropdown.map((dropitem, key) => {
											if (dropitem.shouldExclude) return;
											const activeClassName =
												dropitem.type && dropitem.type === 'external'
													? {}
													: {
														activeClassName: 'active'
													};
											return (
												<div key={key} className={cn('dropdown_suggests-item', dropitem.className)}>
													<Link
														to={dropitem.link}
														target={dropitem.className === 'dashboard-api' ? '_blank' : null}
														{...activeClassName}
													>
														<span className="title">{dropitem.title}</span>
													</Link>
												</div>
											);
										})}
									</div>
								)}
							</li>
						)
				)}
			</ul>
		</nav>
	);
};

Menu.propTypes = propTypes;
export default Menu;



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/sidebar/menu/main.js